module.exports = __webpack_public_path__ + "media/images/wind-cf78a917c1304f51eb1c8baddd7a65a0.png";